import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography } from "@bookips/sds";
import { Controller, useFormContext } from "react-hook-form";
import { PDFIcon } from "../icon/IconList";
import FileUploadBox from "./FileUploadBox";
import SectionContainer from "./SectionContainer";
const FileUpload = ()=>{
    const { control , setValue , clearErrors , formState: { errors  }  } = useFormContext();
    const notices = [
        "와이어 제본은 400페이지까지 1권으로 제작할 수 있어요.",
        "등록하신 PDF 파일의 문제가 있는 경우, 개별적으로 연락을 드려요.",
        "인쇄는 양면이 기본이에요. 단면 인쇄를 원할 경우 추가 요청사항에 따로 적어주세요."
    ];
    return /*#__PURE__*/ _jsxs(SectionContainer, {
        title: "제본 PDF 파일 등록",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Controller, {
                        control: control,
                        name: "pdfFile",
                        rules: {
                            required: "파일 등록이 필요해요."
                        },
                        render: (param)=>{
                            let { field  } = param;
                            var _errors_pdfFile;
                            /*#__PURE__*/ return _jsx(FileUploadBox, {
                                icon: PDFIcon,
                                title: "PDF 파일 등록",
                                description: "100MB 이하로 1개만 등록 가능해요.",
                                fileType: "pdf",
                                onFileSelect: (file)=>{
                                    setValue("pdfFile", file);
                                    clearErrors("pdfFile");
                                },
                                file: field.value,
                                ref: field.ref,
                                error: !!errors.pdfFile,
                                errorMessage: (_errors_pdfFile = errors.pdfFile) === null || _errors_pdfFile === void 0 ? void 0 : _errors_pdfFile.message,
                                onPdfPageCountChange: (pageCount)=>{
                                    setValue("pdfPageCount", pageCount);
                                }
                            });
                        }
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "bg-gray-0 rounded-md px-5 py-4 flex flex-col items-center justify-center mt-3",
                        children: [
                            /*#__PURE__*/ _jsxs(Typography, {
                                variant: "subtitle1",
                                className: "text-primary-main text-center",
                                children: [
                                    "A4 규격(210 * 297 mm)",
                                    /*#__PURE__*/ _jsxs(Typography, {
                                        variant: "subtitle1",
                                        className: "text-primary",
                                        as: "span",
                                        children: [
                                            "을 확인 후 ",
                                            /*#__PURE__*/ _jsx("br", {
                                                className: "sm:hidden"
                                            }),
                                            "등록해주세요."
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                variant: "body2",
                                className: "text-secondary mt-2 text-center",
                                as: "span",
                                children: "다른 규격의 자료 제본은 추후 지원될 예정이에요."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "subtitle1",
                        className: "text-primary mb-2 block",
                        children: "유의사항"
                    }),
                    /*#__PURE__*/ _jsx("ul", {
                        className: "pl-6",
                        children: notices.map((notice, index)=>/*#__PURE__*/ _jsx("li", {
                                className: "marker:text-secondary marker:text-sm list-disc list-item",
                                children: /*#__PURE__*/ _jsx(Typography, {
                                    variant: "body1",
                                    className: "text-secondary",
                                    as: "span",
                                    children: notice
                                })
                            }, index))
                    })
                ]
            })
        ]
    });
};
export default FileUpload;
